var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{attrs:{"size":_vm.size}},[_c('v-img',{attrs:{"src":`https://file.poincampus.com/assets/sns/${_vm.snsType}-circle.svg`,"alt":_vm.snsType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }